'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRequiredIf = require('react-required-if');

var _reactRequiredIf2 = _interopRequireDefault(_reactRequiredIf);

var _Text = require('../Text');

var _Text2 = _interopRequireDefault(_Text);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _LoadingIndicator = require('../LoadingIndicator');

var _LoadingIndicator2 = _interopRequireDefault(_LoadingIndicator);

var _withLayout = require('../withLayout');

var _withLayout2 = _interopRequireDefault(_withLayout);

var _withSpacing = require('../withSpacing');

var _withSpacing2 = _interopRequireDefault(_withSpacing);

var _themes = require('../../lib/themes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var styles = {
  'screen-small': '(max-width: 539px)',
  'screen-gt-small': '(min-width: 540px)',
  'screen-medium': '(max-width: 959px)',
  'screen-gt-medium': '(min-width: 960px)',
  'screen-large': '(max-width: 1247px)',
  'screen-gt-large': '(min-width: 1248px)',
  'screen-x-large': '(max-width: 1919px)',
  'screen-gt-x-large': '(min-width: 1920px)',
  'primary': 'tcl__Button-233931c2',
  'secondary': 'tcl__Button-5f83ec16',
  'tertiary': 'tcl__Button-507a01f1',
  'link': 'tcl__Button-778592d6',
  'isLoading': 'tcl__Button-eabd6038',
  'icon': 'tcl__Button-72271eb9',
  'label': 'tcl__Button-f4ead69c',
  'loadingIndicator': 'tcl__Button-bcc9a0f0',
  'isStandaloneIcon': 'tcl__Button-b529b44d',
  'separator': 'tcl__Button-5620833d',
  'isActive': 'tcl__Button-3515b358',
  'isDestructive': 'tcl__Button-bf6af548',
  'primaryInGroup': 'tcl__Button-575818cf',
  'secondaryInGroup': 'tcl__Button-7cb0a0e2',
  'tertiaryInGroup': 'tcl__Button-c36dab23'
};

/**
 * Use buttons for in-page actions. For navigation use native links instead as
 * they provide better accessibility.
 */

var Button = function Button(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      label = _ref.label,
      icon = _ref.icon,
      theme = _ref.theme,
      isLoading = _ref.isLoading,
      isDisabled = _ref.isDisabled,
      isActive = _ref.isActive,
      isDestructive = _ref.isDestructive,
      accessibilityLabel = _ref.accessibilityLabel,
      buttonRef = _ref.buttonRef,
      props = _objectWithoutProperties(_ref, ['className', 'disabled', 'label', 'icon', 'theme', 'isLoading', 'isDisabled', 'isActive', 'isDestructive', 'accessibilityLabel', 'buttonRef']);

  var isStandaloneIcon = icon && !label;

  return _react2.default.createElement(
    'button',
    _extends({}, props, {
      className: (0, _classnames2.default)(styles[theme], className, isLoading && styles.isLoading, isDisabled && styles.isDisabled, isActive && styles.isActive, isDestructive && styles.isDestructive, isStandaloneIcon && styles.isStandaloneIcon),
      ref: buttonRef,
      disabled: isDisabled || disabled || isLoading,
      'aria-label': accessibilityLabel || label
    }),
    icon && _react2.default.createElement(_Icon2.default, { name: icon, size: 18, className: styles.icon }),
    icon && label && _react2.default.createElement('span', { className: styles.separator }),
    label && _react2.default.createElement(
      _Text2.default,
      { inline: true, className: styles.label },
      label
    ),
    isLoading && _react2.default.createElement(_LoadingIndicator2.default, { className: styles.loadingIndicator })
  );
};

Button.displayName = 'Button';
Button.propTypes = _extends({}, _withLayout.propTypes, _withSpacing.propTypes, {

  /**
   * The text content of the button. It is required if you don't provide an `icon`.
   */
  label: (0, _reactRequiredIf2.default)(_propTypes2.default.string, function (props) {
    return !props.icon;
  }),

  /**
   * The leading icon displayed before the label, or as standalone. If using an icon
   * standalone, the `accessibilityLabel` is required.
   */
  icon: _propTypes2.default.string,

  /**
   * The different themes for a button. Prefer native anchor tags over "link" whenever
   * possible.
   */
  theme: _propTypes2.default.oneOf(_themes.BUTTON_THEMES),

  /**
   * Whether the button is loading. When loading it is automatically disabled.
   */
  isLoading: _propTypes2.default.bool,

  /**
   * Whether the button is disabled.
   */
  isDisabled: _propTypes2.default.bool,

  /**
   * Force the button to appear as though in an pressed state.
   */
  isActive: _propTypes2.default.bool,

  /**
   * Whether the button represents a "destructive" action.
   */
  isDestructive: _propTypes2.default.bool,

  /**
   * If button only contains a standalone icon, the `accessibilityLabel` is required
   * to make the button usable with screen readers.
   */
  accessibilityLabel: (0, _reactRequiredIf2.default)(_propTypes2.default.string, function (props) {
    return !props.label;
  }),

  /**
   * Reference to native <button> element.
   */
  buttonRef: _propTypes2.default.func
});

Button.defaultProps = {
  theme: 'primary'
};

exports.default = (0, _withLayout2.default)((0, _withSpacing2.default)(Button));